import React, { Component } from 'react';
import IconButton from '@material-ui/core/IconButton';

import DefaultButton from '../../Buttons/DefaultButton/DefaultButton';
import DialogComponent from '../../HelperComponents/DialogComponent/DialogComponent';
import PriceListLocationPicker from '../../PriceList/PriceListLocationPicker/PriceListLocationPicker';

import CloseDialogIcon from '../../../assets/image/Mask.png';

import './ReturnDispatchOfferToStockDialog.scss';

class ReturnDispatchOfferToStockDialog extends Component {
    state = {
        location: '',
        priceListId: null,
    };

    componentDidUpdate(prevProps) {
        if ((!prevProps.open && this.props.open) || prevProps.product !== this.props.product) {
            this.setState({ location: '', priceListId: null });
        }
    }

    handlePickerChange = ({ location, priceListId }) => {
        this.setState({ location, priceListId });
    };

    handleSubmit = () => {
        const { onSubmit, product } = this.props;
        const { location, priceListId } = this.state;
        const trimmedLocation = location.trim();
        if (!product || !priceListId || !trimmedLocation) return;

        const data = {
            dispatch_product_id: product.id,
            price_list: priceListId,
            location: trimmedLocation,
        };

        onSubmit(data);
    };

    render() {
        const { loading, onClose, open, product } = this.props;
        const { location, priceListId } = this.state;
        if (!product) return null;

        return (
            <DialogComponent open={open} onClose={loading ? undefined : onClose} maxWidth="md">
                <div className="return_dispatch_stock_dialog">
                    <div className="title-dialog">Одобрить на склад</div>
                    <div className="return_dispatch_stock_dialog__description">
                        Выберите прайс-лист для товара{' '}
                        <span>
                            {product.article_number}
                            {product.name ? ` — ${product.name}` : ''}
                        </span>
                    </div>
                    <PriceListLocationPicker onChange={this.handlePickerChange} />
                    <div className="btn-wrapper order-dialog-btn">
                        <DefaultButton
                            variant="outlined"
                            classes="cancel_btn"
                            disabled={loading}
                            onClick={onClose}
                        >
                            ОТМЕНА
                        </DefaultButton>
                        <DefaultButton
                            disabled={loading || !priceListId || !location.trim()}
                            loading={loading}
                            onClick={this.handleSubmit}
                        >
                            ОДОБРИТЬ НА СКЛАД
                        </DefaultButton>
                    </div>
                    <IconButton
                        classes={{ root: 'dialog_close_button' }}
                        disabled={loading}
                        onClick={onClose}
                    >
                        <img src={CloseDialogIcon} alt="Закрыть" />
                    </IconButton>
                </div>
            </DialogComponent>
        );
    }
}

export default ReturnDispatchOfferToStockDialog;
